module.exports = __webpack_public_path__ + "static/media/enem2020.50b3ec75.png";